import { FilterTimeFrameValue } from "server/config-api/index.js";

import { getTimeFrame } from "./filterTimeFrame";

export enum Granularity {
  NONE = "none",
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
  QUARTER = "quarter",
  YEAR = "year",
}

export const getPeriodicity = (currentStartTime: string) => {
  if (
    currentStartTime ===
    getTimeFrame(FilterTimeFrameValue.Last6FullMonths).startTimeISO
  ) {
    return "last6CompletedMonths";
  }
  if (
    currentStartTime ===
    getTimeFrame(FilterTimeFrameValue.LastFullYear).startTimeISO
  ) {
    return "last12CompletedMonths";
  }

  return "last6CompletedMonths";
};
